import axios from './index'
import store from "../store";
import prefix_ms from './prefix'


// /v2/userArticleFavorite/list 获取收藏文章列表
export const collectionList = (params) => {
  return axios.request({
    url: `${prefix_ms}/userArticleFavorite/list`,
    method: 'get',
    params: params,
  })
}

///v2/userArticleFavorite/add 加入收藏夹
export const joidCollections = (params) => {
  return axios.request({
    url: `${prefix_ms}/userArticleFavorite/add`,
    method: 'post',
    params: params,
  })
}

//v2/userArticleFavorite/remove 移出收藏夹
export const removeCollections = (params) => {
  return axios.request({
    url: `${prefix_ms}/userArticleFavorite/remove`,
    method: 'post',
    params: params,
  })
}


//////////////////
// WEBPACK FOOTER
// ./app/api/collection.js
// module id = null
// module chunks = 